import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Flame, Loader2, Lock } from "lucide-react";

const inputCls =
  "bg-white/5 border-white/15 text-white placeholder:text-white/30 focus-visible:ring-1 focus-visible:ring-[#E8954A] focus-visible:border-[#E8954A] rounded-sm h-12";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user && user.email) navigate("/admin");
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) navigate("/admin");
    else setError(res.error);
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-2.5 justify-center mb-8">
          <Flame className="w-7 h-7 text-[#E8954A]" strokeWidth={2.2} />
          <span className="font-display font-extrabold tracking-tight text-xl uppercase">Iron Fire</span>
        </div>
        <div className="border border-white/10 rounded-sm bg-[#141414] p-8">
          <div className="flex items-center gap-2 mb-1.5 text-[#E8954A]">
            <Lock className="w-4 h-4" />
            <p className="text-xs tracking-[0.2em] uppercase font-bold">Control Room</p>
          </div>
          <h1 className="font-display text-2xl font-bold tracking-tight mb-6">Admin Sign In</h1>
          <form onSubmit={submit} className="space-y-4">
            <div className="space-y-1.5">
              <Label className="text-white/70 text-xs">Email</Label>
              <Input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} placeholder="admin@ironfireproductions.com" />
            </div>
            <div className="space-y-1.5">
              <Label className="text-white/70 text-xs">Password</Label>
              <Input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} placeholder="••••••••" />
            </div>
            {error && <p data-testid="login-error" className="text-[#FF3B30] text-sm">{error}</p>}
            <button
              type="submit"
              data-testid="login-submit"
              disabled={loading}
              className="w-full bg-white text-black font-semibold py-3.5 rounded-sm hover:bg-[#E8954A] transition-colors flex items-center justify-center gap-2 disabled:opacity-60"
            >
              {loading && <Loader2 className="w-4 h-4 animate-spin" />}
              Sign In
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
